$(() => {
  $('.js-gallery-popup').each(function () {
    $(this).magnificPopup({
      delegate: '.js-gallery-item',
      type: 'image',
      gallery: { enabled: true },
    })
  })
})
